import { render, staticRenderFns } from "./feedbackChart.vue?vue&type=template&id=67e8308e&scoped=true"
import script from "./feedbackChart.vue?vue&type=script&lang=js"
export * from "./feedbackChart.vue?vue&type=script&lang=js"
import style0 from "./feedbackChart.vue?vue&type=style&index=0&id=67e8308e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67e8308e",
  null
  
)

export default component.exports